/* eslint-disable no-unused-vars */

<template ref='bm'>
  <div>
      <div class="container">
    <h1><font-awesome-icon icon="home" /> Home -  <a href="#">Process Payment </a></h1>

<div class="row">
<div class="col-md-12">
<div class="panal mt-20">
<div class="panal-header">Payment list </div>
<div class="panal-body " >
    <div class="table table-responsive col-md-10  m-auto">
        <table  id="ChargesTable" border="1"  class="tabel" width="100%">
            <thead>
                <tr class="text-uppercase jumbotron" style="text-transform:capitalize">
                    
                    <th align="center" class="text-center"><strong>Payment Name</strong></th>
                    <th align="center" class="text-center"><strong>Value</strong></th>
                </tr>
            </thead>

            <tbody class="text-center" id="ChargesTableData">
                <tr v-for="(data,index) in products" v-bind:key="index">
                   
                    <td>{{data.Description}}
                    </td>
                   
                    <td>{{data.Price}}
                    </td>
                   
                    </tr>
                   
            </tbody>
            <tfoot>
                <tr class="text-center">
                    <td class="bg-gray">Total Amount</td>
                    <td>{{TotalAmount}}</td>
                </tr>
            </tfoot>
        </table>
      </div> 
        <p class="mt-50 alert alert-warning">  Please Review your payment List Carefully then Press Confirm Button </p>

 <div class="text-center">
<b-link class="btn btn-primary mr-20" @click="$router.push('wallet')">

                       <i class="fa fa-backword"></i>back
                      </b-link>
         <input type="button" value="confirm" @click="callLightbox" class="btn btn-success" />
         
 </div>       <!-- <input type="image" class="mt-50" @click="GetMerchantRefNumber" src="https://www.atfawry.com/ECommercePlugin/resources/images/atfawry-ar-logo.png" alt="Edfa3 Fawry" id="xsrrs" /> -->
    </div>
    <div class="text-center">
        <b-modal id="confirm" title="Payment Completed" :header-bg-variant="headerBgVariant" ok-only @ok="GoWallet"  cancel-disabled no-close-on-esc no-close-on-backdrop>
    <p class="my-4 text-center"> <b-icon icon="bell-fill" class="  p-2 text-success"></b-icon></p>
    <p class="text-center">

      

      Payment Completed <br/>

            Thank You!
    </p>
    
    
  </b-modal>
        <b-modal id="Failed" title="Payment Failed" :header-bg-variant="headerBgVariant" ok-only @ok="GoWallet"  cancel-disabled no-close-on-esc no-close-on-backdrop>
    <p class="my-4 text-center"> <b-icon icon="bell-fill" class="  p-2 text-danger"></b-icon></p>
    <p class="text-center">

      

      Payment Failed <br/>

            Please Try again later! 
            <br>
       Error :      {{    SUerrorMessage}}
    </p>
    
    
  </b-modal>
    </div>
  </div>
</div>
</div>
      </div>
  </div>
  
</template>
<!--<script src="https://banquemisr.gateway.mastercard.com/checkout/version/58/checkout.js"
            data-error="errorCallback"
            data-cancel="cancelCallback"
            data-beforeRedirect="beforeRedirect"
            data-afterRedirect="afterRedirect"
            data-complete="completeCallback">
    </script>-->
<script>
import axios from 'axios'

// eslint-disable-next-line
     


import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
import{API_URL} from '../../services/API_URL'

export default {
    

   data(){
       return{
        headerBgVariant:'primary',
    ChargesTableData:[],
    products : [],
    Lst : [],
    
    result : '',
    orderId : '',
    paymentMethodFromLightBox: null ,
    mID : "10356532694",
    tID : "70473567",
    secureHash: '',
    trxDateTime:'',
    MerchantReference:'',
    Amount:'',
    TotalAmount:'',
    SUerrorMessage:''
       }
   },
   beforeMount() {
       
              if(this.PaymentStore.length == 0 ) this.$router.push('/wallet')

                 let  scripts = [
      "https://upgstaglightbox.egyptianbanks.com/js/Lightbox.js", // testing

      
    ];
     scripts.forEach(script => {
      let tag = document.createElement("script");
      tag.setAttribute('type', "text/javascript") ;
      tag.setAttribute("src", script);
      tag.defer =true;
      document.head.appendChild(tag);
    });


  },
   mounted(){
    
   
      
       this.PaymentStore.forEach(element => {
         var product = {};
        product.PaymentID  = element.PaymentID;
        product.Description = element.Description;
        product.Price       = element.Price;
        
        this.products.push(product);
        ApplicantDataServices.ApplicantUPDRepeatedPaymnet(element.PaymentID).then( response => 
        {
            if(response.data == 1) this.$router.push('/wallet')
        })
    });
    ApplicantDataServices.ApplicantBankMasr_UPG(this.currentUser.UserIDSerial ,this.products).then(Result =>{
        // eslint-disable-next-line
        console.log(Result.data)
        if (Result.data) {
                        this.secureHash = Result.data.SecureHash;
                    this.trxDateTime = Result.data.DateTimeLocal;
                    this.MerchantReference = Result.data.MerchantReference;
                    this.Amount = Result.data.Amount;
                    this.TotalAmount = Result.data.TotalAmount
                    //this.callLightbox();


                       
                         
                       
                    }else{
                        this.$router.push('/wallet')
                    }
    }).catch( // this.$router.push('/wallet')
    )
   },
   methods:
   {
       
         callLightbox() {
           
           // check new api if found = 0 proceed any other value back to wallet  
ApplicantDataServices.ApplicantBankMasr_UPGScheckIfPaymentRepet(this.MerchantReference).then(res=> {
    if(res.data == 0 ){
       Lightbox.Checkout.configure = {
                OrderId: this.orderId,
                paymentMethodFromLightBox: this.paymentMethodFromLightBox,
                MID: this.mID,
                TID: this.tID,
                SecureHash: this.secureHash,
                TrxDateTime: this.trxDateTime,
                AmountTrxn: this.Amount,
                MerchantReference: this.MerchantReference,

                completeCallback:(data)=> this.CallBackDetails(data) ,
                    
                errorCallback:(data)=>this.ErrorCallBackDetails(data),
                // eslint-disable-next-line no-unused-vars
                cancelCallback: (res) =>{
                    //your code here
                    this.$router.push('/wallet')

                }
            };
            Lightbox.Checkout.showLightbox();
    }else{
            this.$router.push('/wallet')
    }
})
          
     
        },

 CallBackDetails(data) {
           
            axios.post(API_URL+'BankMasr_UPG/UPG_CallBackDetails',{
                    IsError: false,
                    TxnDate: data.TxnDate,
                    SystemReference: data.SystemReference,
                    NetworkReference: data.NetworkReference,
                    MerchantReference: data.MerchantReference,
                    Amount: data.Amount,
                    Currency: data.Currency,
                    PaidThrough: data.PaidThrough,
                    PayerAccount: data.PayerAccount,
                    PayerName: data.PayerName,
                    ProviderSchemeName: data.ProviderSchemeName,
                    SecureHash: data.SecureHash//,
                    //Error: data.error,
                    //ErrorAmount: data.Amount,
                    //ErrorMerchantReferenece: data.MerchantReferenece,
                    //ErrorDateTimeLocalTrxn: data.DateTimeLocalTrxn,
                    //ErrorSecureHash: data.SecureHash
                },{}).then(()=>{
                    this.$bvModal.show("confirm")
                    Lightbox.Checkout.closeLightbox()
                    }).catch(()=>{ this.$router.push('/wallet')})
       
        },
        

         ErrorCallBackDetails(data) {
          
           axios.post(API_URL+"/BankMasr_UPG/UPG_CallBackDetails",{
               IsError: true,
                    //TxnDate: data.TxnDate,
                    //SystemReference: data.SystemReference,
                    //NetworkReference: data.NetworkReference,
                    //MerchantReference: data.MerchantReference,
                    //Amount: data.Amount,
                    //Currency: data.Currency,
                    //PaidThrough: data.PaidThrough,
                    //PayerAccount: data.PayerAccount,
                    //PayerName: data.PayerName,
                    //ProviderSchemeName: data.ProviderSchemeName,
                    //SecureHash: data.SecureHash,
                    Error: data.error,
                    ErrorAmount: data.Amount,
                    ErrorMerchantReferenece: data.MerchantReferenece,
                    ErrorDateTimeLocalTrxn: data.DateTimeLocalTrxn,
                    // eslint-disable-next-line no-unused-vars
                    ErrorSecureHash: data.SecureHash})
                    .then(res=>{ 
                    console.log('error',res)
                     this.SUerrorMessage = data.error
                    this.$bvModal.show("Failed")
                    //document.getElementById('mainclose').click()
                     Lightbox.Checkout.closeLightbox()
                    //this.$router.push('/wallet')
                  

                    })
                    .catch(()=>this.$router.push('/wallet'))

           
        },






      
GoWallet(){
this.$router.push('/wallet')
}

   },
   computed:{
       PaymentStore(){
              return this.$store.state.auth.paymentList 
        },
     currentUser() {
        return this.$store.state.auth.user
      },
      reviewApplication(){
       return  this.$store.state.auth.renderReview 
       }


   }

}
</script>

<style>
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#50BD77;
}
table tr th {
    background-color: #4caf5000 !important;
    color:#333;
    font-weight:bold;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}
.app-stu-photo{
    float:right;
    width:200px;
    border-radius:10px;
    border:1px solid #111;
    margin-top:20px;
}
.app-stu-photo img{
    width:100%;
      border-radius:10px;
      
}
.app-All{
    width:80%;
    float:left;
}
.app-stu{
    border-bottom:1px #333 dotted;
    padding:10px 0px;

}
.app-stu .title{
    font-weight:bold;

}

.app-stu .title span{
    font-weight: 100;


    
}

.table .thead-light th {

    font-size: 14px !important;
}
.mt-50{
    margin-top: 50px !important;
}
.m-auto{
    margin: auto !important;
}
bg-gray{
    background-color: #eee;
}
.mr-20{
    margin-right: 20px;
}
.modal-dialog {
    width: 600px;
    margin: 20px 30% auto !important;
}
.modal.in .modal-dialog {
    -webkit-transform: translate(0,0);
    -ms-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
    margin: 30px 30% !important;
}
</style>